import { render } from "./S74160.vue?vue&type=template&id=5848fa87"
const script = {}
script.render = render

export default script